import React, { useState } from 'react';
import './howToVideos.css';

const VIDEOS = [
  {
    id: 'voice-notes', label: 'Capture a moment', title: 'Start with a voice note',
    description: 'See how a spoken note becomes organized care information you can return to later.',
  },
  {
    id: 'forward-email', label: 'Forward an email', title: 'Bring an email into Lifelog',
    description: 'Learn how email forwarding brings updates into your loved one’s care history.',
  },
  {
    id: 'import-history', label: 'Import past records', title: 'Bring your existing history along',
    description: 'Walk through importing a document so past care details can become part of the record.',
  },
  {
    id: 'ask-history', label: 'Ask your history', title: 'Find answers in what you’ve saved',
    description: 'See how Ask helps you explore your saved care history and find the details behind an answer.',
  },
];

const HowToVideos = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selected = VIDEOS[selectedIndex];

  return (
    <section className="how-to-videos" id="how-to-videos" aria-labelledby="how-to-videos-title">
      <div className="how-to-videos-heading">
        <span className="demo-kicker">Watch at your own pace</span>
        <h2 id="how-to-videos-title">A little help getting started.</h2>
        <p>Start with everyday updates, bring in past records, then explore what you’ve saved. Choose any video below.</p>
      </div>
      <div className="how-to-video-choices" role="group" aria-label="Choose a how-to video">
        {VIDEOS.map((video, index) => (
          <button
            key={video.id}
            type="button"
            aria-pressed={selectedIndex === index}
            aria-controls="how-to-video-player"
            onClick={() => setSelectedIndex(index)}
          >
            <span aria-hidden="true">{index + 1}</span>{video.label}
          </button>
        ))}
      </div>
      <div className="how-to-video-card" id="how-to-video-player">
        <div className="how-to-video-description" aria-live="polite" aria-atomic="true">
          <h3 id="how-to-video-name">{selected.title}</h3>
          <p>{selected.description}</p>
        </div>
        <video key={selected.id} controls playsInline preload="none" poster="/media/how-it-works/video-poster.svg" aria-labelledby="how-to-video-name">
          <source src={`/media/how-it-works/${selected.id}.mp4`} type="video/mp4" />
          Your browser does not support video playback.
        </video>
        <a className="how-to-video-open" href={`/media/how-it-works/${selected.id}.mp4`} target="_blank" rel="noopener noreferrer">
          Open this video in a new tab ↗
        </a>
      </div>
    </section>
  );
};
export default HowToVideos;
